import { getRequest, postRequest } from './httpServices';
import { API_ROUTES } from './route';

// Fetch About Page Data
export const getAboutData = async () => {
  try {
    const response = await getRequest(API_ROUTES.ABOUT.GET);
    return response; 
  } catch (error) {
    console.error("Error fetching about data in service:", error);
    throw error;
  }
};

// Submit Careers Application Form Data
export const addCareersData = async (data, config = {}) => {
  try {
    const response = await postRequest(API_ROUTES.CAREERS.ADD, data, config);
    return response;
  } catch (error) {
    console.error("Error submitting careers data in service:", error);
    throw error;
  }
};

// Fetch Approvals Data
export const getApprovals = async () => {
  try {
    const response = await getRequest(API_ROUTES.APPROVALS.GET);
    return response;
  } catch (error) {
    console.error("Error fetching approvals in service:", error);
    throw error;
  }
};

// Fetch Gallery Data
export const getGallery = async () => {
  try {
    const response = await getRequest(API_ROUTES.GALLERY.GET);
    return response;
  } catch (error) {
    console.error("Error fetching gallery in service:", error);
    throw error;
  }
};

// Fetch NCC Data
export const getNcc = async () => {
  try {
    const response = await getRequest(API_ROUTES.NCC.GET);
    return response;
  } catch (error) {
    console.error("Error fetching NCC in service:", error);
    throw error;
  }
};

// Fetch IIC Data
export const getIic = async () => {
  try {
    const response = await getRequest(API_ROUTES.IIC.GET);
    return response;
  } catch (error) {
    console.error("Error fetching IIC in service:", error);
    throw error;
  }
};

// Fetch Privacy Policy Data
export const getPrivacyPolicy = async () => {
  try {
    const response = await getRequest(API_ROUTES.PRIVACY.GET);
    return response;
  } catch (error) {
    console.error("Error fetching Privacy Policy in service:", error);
    throw error;
  }
};

// Fetch Terms & Conditions Data
export const getTermsConditions = async () => {
  try {
    const response = await getRequest(API_ROUTES.TERMS.GET);
    return response;
  } catch (error) {
    console.error("Error fetching Terms & Conditions in service:", error);
    throw error;
  }
};

export const getGlobalDepartments = async () => {
  try {
    return await getRequest(API_ROUTES.GLOBAL_DEPARTMENTS.GET);
  } catch (error) {
    console.error("Error fetching global departments:", error);
    throw error;
  }
};

export const getDepartments = async () => {
  try {
    return await getRequest(API_ROUTES.DEPARTMENTS.BASE);
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const getDepartmentDetails = async (id) => {
  try {
    return await getRequest(`${API_ROUTES.DEPARTMENT_DETAILS.BASE}/${id}`);
  } catch (error) {
    console.error("Error fetching department details:", error);
    throw error;
  }
};

export const getBlogs = async () => {
  try {
    return await getRequest(API_ROUTES.BLOGS.BASE);
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const getBlogById = async (id) => {
  try {
    return await getRequest(`${API_ROUTES.BLOGS.BASE}/${id}`);
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error;
  }
};

export const getAuditReports = async () => {
  try {
    return await getRequest(API_ROUTES.AUDIT_REPORTS.GET);
  } catch (error) {
    console.error("Error fetching audit reports:", error);
    throw error;
  }
};

export const getMonthlyReports = async () => {
  try {
    return await getRequest(API_ROUTES.MONTHLY_REPORTS.GET);
  } catch (error) {
    console.error("Error fetching monthly reports:", error);
    throw error;
  }
};

export const getExamination = async () => {
  try {
    return await getRequest(API_ROUTES.EXAMINATION.GET);
  } catch (error) {
    console.error("Error fetching examination:", error);
    throw error;
  }
};

export const getIqac = async () => {
  try {
    return await getRequest(API_ROUTES.IQAC.GET);
  } catch (error) {
    console.error("Error fetching iqac:", error);
    throw error;
  }
};

export const getNispPolicy = async () => {
  try {
    return await getRequest(API_ROUTES.NISP_POLICY.GET);
  } catch (error) {
    console.error("Error fetching NISP policy:", error);
    throw error;
  }
};

export const getResearch = async () => {
  try {
    return await getRequest(API_ROUTES.RESEARCH.GET);
  } catch (error) {
    console.error("Error fetching research:", error);
    throw error;
  }
};

export const getIdeaLab = async () => {
  try {
    return await getRequest(API_ROUTES.IDEA_LAB.GET);
  } catch (error) {
    console.error("Error fetching IDEA Lab:", error);
    throw error;
  }
};

export const getNirf = async () => {
  try {
    return await getRequest(API_ROUTES.NIRF.GET);
  } catch (error) {
    console.error("Error fetching NIRF:", error);
    throw error;
  }
};

export const getSamashti = async () => {
  try {
    return await getRequest(API_ROUTES.SAMASHTI.GET);
  } catch (error) {
    console.error("Error fetching Samashti:", error);
    throw error;
  }
};

export const getPlacements = async () => {
  try {
    return await getRequest(API_ROUTES.PLACEMENTS.GET);
  } catch (error) {
    console.error("Error fetching Placements:", error);
    throw error;
  }
};

export const getHome = async () => {
  try {
    return await getRequest(API_ROUTES.HOME.GET);
  } catch (error) {
    console.error("Error fetching Home:", error);
    throw error;
  }
};

export const getAutonomousRegulations = async () => {
  try {
    return await getRequest(API_ROUTES.AUTONOMOUS_REGULATIONS.GET);
  } catch (error) {
    console.error("Error fetching Autonomous Regulations:", error);
    throw error;
  }
};

export const getAlumniCommittee = async () => {
  try {
    return await getRequest(API_ROUTES.ALUMNI_COMMITTEE.GET);
  } catch (error) {
    console.error("Error fetching Alumni Committee:", error);
    throw error;
  }
};

// Fetch NBA Visit Data page content (singleton)
export const getNbaVisitData = async () => {
  try {
    return await getRequest(API_ROUTES.NBA_VISIT_DATA.GET);
  } catch (error) {
    console.error("Error fetching NBA Visit Data:", error);
    throw error;
  }
};

// Fetch Hostel page content (singleton)
export const getHostel = async () => {
  try {
    return await getRequest(API_ROUTES.HOSTEL.GET);
  } catch (error) {
    console.error("Error fetching Hostel:", error);
    throw error;
  }
};

// Fetch Careers page content (singleton) — banner, selector, form option lists
export const getCareersPage = async () => {
  try {
    return await getRequest(API_ROUTES.CAREERS_PAGE.GET);
  } catch (error) {
    console.error("Error fetching Careers page content:", error);
    throw error;
  }
};

// Fetch current Job openings (collection) — the "Current Openings" section on /careers
export const getJobs = async () => {
  try {
    return await getRequest(API_ROUTES.JOBS.GET);
  } catch (error) {
    console.error("Error fetching job openings:", error);
    throw error;
  }
};

// Fetch live openings from the NCET ERP (backend proxies + falls back to the
// local Job collection) — preferred source for the /careers "Current Openings".
export const getErpJobs = async () => {
  try {
    return await getRequest(API_ROUTES.ERP_JOBS.GET);
  } catch (error) {
    console.error("Error fetching ERP job openings:", error);
    throw error;
  }
};

// Fetch Contact page content (singleton) — banner, forms copy, Get-In-Touch, options
export const getContactPage = async () => {
  try {
    return await getRequest(API_ROUTES.CONTACT_PAGE.GET);
  } catch (error) {
    console.error("Error fetching Contact page content:", error);
    throw error;
  }
};

// Fetch Admission Process page content (singleton)
export const getAdmissionPage = async () => {
  try {
    return await getRequest(API_ROUTES.ADMISSION_PAGE.GET);
  } catch (error) {
    console.error("Error fetching Admission page content:", error);
    throw error;
  }
};

// Fetch global site settings (singleton) — header/footer logos, social, contact.
// Site settings are a global singleton rendered on EVERY page (Header + Footer),
// so both components (and every route change) would otherwise re-request it.
// We memoize the in-flight/resolved promise so it's fetched once per session:
// concurrent callers share one request, and later navigations reuse the result
// with no network at all. A failed fetch clears the cache so the next mount retries.
// (A full page reload re-fetches — fine for global chrome that rarely changes.)
let _siteSettingsPromise = null;
export const getSiteSettings = async () => {
  if (_siteSettingsPromise) return _siteSettingsPromise;
  _siteSettingsPromise = (async () => {
    try {
      return await getRequest(API_ROUTES.SITE_SETTINGS.GET);
    } catch (error) {
      _siteSettingsPromise = null; // allow a retry on the next call
      console.error("Error fetching site settings:", error);
      throw error;
    }
  })();
  return _siteSettingsPromise;
};

// Fetch the page hero-banner map (singleton { "<route>": "<url>" }). Consumed by
// the shared PageBanner component on EVERY page, so — like site settings — we
// memoize it to one request per session (a failed fetch clears the cache to
// allow a retry). Response body carries the map at `res.data.data`.
let _pageBannersPromise = null;
export const getPageBanners = async () => {
  if (_pageBannersPromise) return _pageBannersPromise;
  _pageBannersPromise = (async () => {
    try {
      return await getRequest(API_ROUTES.PAGE_BANNERS.GET);
    } catch (error) {
      _pageBannersPromise = null; // allow a retry on the next call
      console.error("Error fetching page banners:", error);
      throw error;
    }
  })();
  return _pageBannersPromise;
};
